module.exports = __webpack_public_path__ + "static/media/ic-trash.1fac90d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-trash.svg
// module id = 677
// module chunks = 14